import {useEffect, useState} from 'react'
import { setTitlePage, isValidDate } from '../../Functions'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { Link } from 'react-router-dom'
import { getDetailConsultaSearch } from "../../Api";
import { useAuth } from '../../../app/modules/auth'
import PaginationComponent from '../../components/PaginationComponent/PaginationComponent';
import { Modal as ModalBootstrap } from "bootstrap";
import Modal from '../../components/Modal/Modal'
import Axios from "axios";
import Search from './Search';
import Table from './Table';
import QueryDetailBruto from './QueryDetailBruto';
import QueryDetail from './QueryDetail';
import { AlertDialog } from '../../components/Dialog/Dialog';
import GlobalLoading from '../../components/GlobalLoading';

const PaymentDetail = () => {
  const [showAlertError, setShowAlertError] = useState(false);
  const [messageAlertError, setMessageAlertError] = useState('No se encontraron resultados para tu búsqueda.');
  const [loadingExcel, setLoadingExcel] = useState(false);
  const { auth } = useAuth();
  const [state, setState] = useState({
    data: [],
    pageCount: 0,
    pageIndex: 0,
    pageSize: 0,
    pages: 0,
    loading: false,
  });
  const [filters, setFilters] = useState({
    tipopago: '0',
    estado: '0',
    start_date: '',
    end_date: ''
  });
  const [resume, setResume] = useState({});
  const [detail, setDetail] = useState({});

  useEffect(() => {
    setTitlePage('Detalle de liquidaciones');
  }, [])

  const onChange= e => {
    const { name, value } = e.target;
    setFilters({...filters, [name]: value});
  }

  const openModalResume = (row) => {
    setResume(row);
    const modal = new ModalBootstrap(document.getElementById("SettlementSummary"));
    modal.show();
  }

  const openModalDetail = (row) => {
    setDetail(row);
    const modal = new ModalBootstrap(document.getElementById("Summary"));
    modal.show();
  }

  const loadData = async (pageIndex = 0, pageCount = 10) => {

    const data = {...filters, paginate: pageIndex, numberrecords : pageCount};
    const startDate = data.start_date.length > 0 ?  data.start_date + '-01' : '';
    const endDate = data.end_date.length > 0 ?  data.end_date + '-01' : '';
    if(startDate.length > 0 && !isValidDate(startDate)) {
      setMessageAlertError('El formato de Fecha Desde, es incorrecto!');
      setShowAlertError(true);
      return;
    }
    if(endDate.length > 0 && !isValidDate(endDate)) {
      setMessageAlertError('El formato de Fecha hasta, es incorrecto!');
      setShowAlertError(true);
      return;
    }

    setState({...state, loading: true});
    const _response = await getDetailConsultaSearch(data);
    if (_response?.status) {
      const { totalrecords, paginate, totalpaginate } = _response.data.pagination;
      setState({
        data: _response.data.records,
        pageCount: parseInt(totalrecords),
        pageIndex: parseInt(paginate),
        pageSize: pageCount,
        pages: parseInt(totalpaginate),
        loading: false,
      });
      if (totalrecords === 0) {
        setMessageAlertError('No se encontraron resultados para tu búsqueda.');
        setShowAlertError(true);
      }
    } else {
      setMessageAlertError('No se encontraron resultados para tu búsqueda.');
      setShowAlertError(true);
      setState({
        data: [],
        pageCount: 0,
        pageIndex: 0,
        pageSize: 0,
        pages: 0,
        loading: false,
      });
    }
    
  }

  const downloadExcel = async () => {

    const params = new URLSearchParams(filters).toString();
    const url = process.env.REACT_APP_API_URL;

    setLoadingExcel(true);
    Axios({
      url: `${url}/auth/detallepagos/search?excel=1&${params}`,
      method: "GET",
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${auth.access_token}`
      },
    }).then((response) => {
      if(response.data.status){
        const link = document.createElement("a");
        link.href = response.data.file;
        link.setAttribute('download', `${Date.now()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        alert('No se generó el archivo');
      }
    }).finally(() => {
      setLoadingExcel(false);
    });
  }

  return (
    <>
      <GlobalLoading show={loadingExcel} message="GENERANDO EXCEL" />
      <div className="row mb-2">
        <div className="card col-md-3 offset-md-9">
          <Link to="/grafico/evolutivo/payments" className="btn btn-white me-2 fs-3 fw-bold">
            Evolutivo de Pagos  <img src={toAbsoluteUrl('/media/icons/4146963.png')} style={{ marginLeft: '10px', maxWidth: '50px' }} alt="..." />
          </Link>
        </div>
      </div>

      <Search filters={filters} onChange={onChange} loadData={loadData} downloadExcel={downloadExcel}  />
    
      <Table state={state} openModalResume={openModalResume} openModalDetail={openModalDetail} />

      <Modal id="SettlementSummary" size="modal-xl" title="Resumen de Liquidación">
        <QueryDetailBruto {...resume} />
      </Modal>

      <Modal id="Summary" size="modal-xl" title="Detalle de Liquidación">
        <QueryDetail {...detail} />
      </Modal>
  
      <PaginationComponent totalPages={state.pages} activePage={state.pageIndex} searchData={loadData} loading={state.loading} />

      <AlertDialog
        message={messageAlertError}
        show={showAlertError}
        success={false}
        onConfirm={() => {
            setShowAlertError(false);
        }}
      />
    </>
  )
}

export default PaymentDetail;